import { logAssetOpenAnalytics } from "../../../toolbox"
import logGoogleAnalytics from "./logGoogleAnalytics"

const logAssetOpen = ({ id, type, name, lessonName, subType }) => {
  logGoogleAnalytics(id, "Google Classroom", "download_asset", subType)
  logAssetOpenAnalytics(id, type, name, lessonName, subType)
}

export default logAssetOpen
